import { SchedulingRuleAssign, SchedulingRuleAssignRequest, SchedulingRuleAssignResponse, SchedulingRuleAssignUpdateRequest, SchedulingRuleAssignFilters } from './@types/SchedulingRuleAssing';

export class SchedulingRulesAssignRepository {
    private httpService: IHttpService;
    private baseUrl: string;

    constructor(httpService: IHttpService) {
        this.httpService = httpService;
        this.baseUrl = '/ruleset-assignment';
    }

    async getAll(filters?: SchedulingRuleAssignFilters): Promise<SchedulingRuleAssign[]> {
        try {
            const response = await this.httpService.get<SchedulingRuleAssignResponse>(this.baseUrl, { params: filters });
            return response.data ?? [];
        } catch (error) {
            console.error('Error fetching scheduling rule assignments:', error);
            throw error;
        }
    }

    async create(rules: SchedulingRuleAssign[]): Promise<SchedulingRuleAssign[]> {
        const response = await this.httpService.post<SchedulingRuleAssignResponse | SchedulingRuleAssign[], SchedulingRuleAssign[]>(this.baseUrl, { data: rules });

        if (Array.isArray(response)) {
            return response;
        }

        if (!response?.data) {
            throw new Error('Invalid response creating scheduling rule');
        }

        return response.data;
    }

    async update(ruleset_r_employee_id: number, rule: SchedulingRuleAssignUpdateRequest): Promise<SchedulingRuleAssign> {
        const response = await this.httpService.patch<SchedulingRuleAssignRequest, SchedulingRuleAssignUpdateRequest>(`${this.baseUrl}/${ruleset_r_employee_id}`, { data: rule });
        if (!response?.data) {
            throw new Error('Invalid response updating scheduling rule');
        }

        return response.data;
    }

    async delete(ruleset_id: number): Promise<void> {
        console.log('id', ruleset_id);
        await this.httpService.delete<void>(`${this.baseUrl}/${ruleset_id}`);
    }
}
